export const NOTIFICATION_SYSTEM_STYLE = {
    NotificationItem: {
        DefaultStyle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',

            borderRadius: '4px',
            fontSize: '14px',
        },

        success: {
            borderTop: 0,
            backgroundColor: '#45b649',
            WebkitBoxShadow: 0,
            MozBoxShadow: 0,
            boxShadow: 0,
        },

        error: {
            borderTop: 0,
            backgroundColor: '#f85032',
            WebkitBoxShadow: 0,
            MozBoxShadow: 0,
            boxShadow: 0,
        },

        warning: {
            borderTop: 0,
            backgroundColor: '#ffd700',
            WebkitBoxShadow: 0,
            MozBoxShadow: 0,
            boxShadow: 0,
        },

        info: {
            borderTop: 0,
            background: 'linear-gradient(to right, #6a82fb, #fc5c7d)',
            WebkitBoxShadow: 0,
            MozBoxShadow: 0,
            boxShadow: 0,
        },
    },

    Title: {
        DefaultStyle: {
            margin: 0,
            padding: 0,
            paddingRight: 5,
            color: '#fff',
            display: 'inline-flex',
            fontSize: 20,
            fontWeight: 'bold',
        },
    },

    MessageWrapper: {
        DefaultStyle: {
            display: 'block',
            color: '#fff',
            width: '100%',
        },
    },

    Dismiss: {
        DefaultStyle: {
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: 'inherit',
            fontSize: 20,
            color: '#f2f2f2',
            position: 'relative',
            margin: 0,
            padding: 0,
            background: 'none',
            borderRadius: 0,
            opacity: 1,
            width: 20,
            height: 20,
            textAlign: 'initial',
            float: 'none',
            top: 'unset',
            right: 'unset',
            lineHeight: 'inherit',
        },
    },

    Action: {
        DefaultStyle: {
            background: '#fff',
            borderRadius: '2px',
            padding: '6px 20px',
            fontWeight: 'bold',
            margin: '10px 0 0 0',
            border: 0,
        },

        success: {
            backgroundColor: '#45b649',
            color: '#fff',
        },

        error: {
            backgroundColor: '#f85032',
            color: '#fff',
        },

        warning: {
            backgroundColor: '#ffd700',
            color: '#fff',
        },

        info: {
            backgroundColor: '#00c9ff',
            color: '#fff',
        },
    },

    ActionWrapper: {
        DefaultStyle: {
            margin: 0,
            padding: 0,
        },
    },
};

export enum StoragePath {
    AMENITIES = 'Amenities',
    PARTNER_PROMOTION = 'PartnerPromotion/offerImage',
    PARTNER_CERTIFICATE = 'PartnerPromotion/certificate',
    PARTNER_PROMOTION_LOGO = 'PartnerPromotion/logoImage',
    LOCATION_PAGE_IMAGE = 'PartnerPromotion/locationPageImage',
    RFID_CARDS_IMPORT = 'RFIDCardsImport',
    RFID_CARDS_ALLOCATE = 'RFIDCardsAllocate',
    AMENITY_IMPORT = 'SiteAmenities',
    CHARGE_STATIONS_IMPORT = 'ConnectorPowerRatingImports',
    DRIVER_PROMOTIONS_IMPORT = 'DriverPrmotions',
    IMPORT_ACCOUNT_WITH_RFID = 'ImportAccountWithRFIDCard',
    IMPORT_CARD_READER = 'CardReaderImports',
    TERMS_AND_CONDITIONS = 'TermsAndConditions',
    VIDEO_ASSETS = 'VideoAssets',
    RFID_CARD_REMOVE_ASSOCIATION = 'RemoveRFIDCardsAssociations',
    IMPORT_CHARGE_STATIONS_MODEL = 'ImportChargeStationsModel',
    IMPORT_UPDATE_DRIVER_STATUS = 'UpdateDriverStatusImports',
    DRIVER_DEBTOR_LETTERS = 'DriverDebtorLetters',
    ADDITIONAL_IMAGES = 'PartnerPromotion/additionalImages',
    SUBSCRIPTION_IMAGES = 'PremiumSubscription/images',
}

export class Common {
    public static readonly CPO_TYPE_LIST = Object.freeze({
        BOTH: 'Both',
        LOCAL: 'Local',
        INTERNATIONAL: 'International',
    });
    public static readonly Module = 'Module';
    public static readonly DATEFORMATWITHOUTTIME = 'DD/MM/YYYY';
    public static readonly DATEFORMAT = 'DD/MM/YYYY HH:mm';
    public static readonly DATEFORMATWITHSECONDS = 'DD/MM/YYYY HH:mm:ss';
    public static readonly VIEWACTION = 'VIEW';
    public static readonly ENABLE = 'ENABLE';
    public static readonly REGULAR_DECIMAL_SEPERATOR = '.';
    static Modules = class Modules {
        public static readonly DASHBOARD = Object.freeze({
            DASHBOARD_USER_SESSION: 'DASHBOARD_USER_SESSION',
            DASHBOARD_INCOME: 'DASHBOARD_INCOME',
            DASHBOARD_TRANSACTION: 'DASHBOARD_TRANSACTION',
            DASHBOARD_ENERGY: 'DASHBOARD_ENERGY',
            DASHBOARD_FAILED_PAYMENTS: 'DASHBOARD_FAILED_PAYMENTS',
            DASHBOARD_OUTSTANDING_FAILED_PAYMENTS: 'DASHBOARD_OUTSTANDING_FAILED_PAYMENTS',
            DASHBOARD_DRIVER: 'DASHBOARD_DRIVER',
            DASHBOARD_VOLT_ACCUMULATED: 'DASHBOARD_VOLT_ACCUMULATED',
            DASHBOARD_VOLT_CLAIMED: 'DASHBOARD_VOLT_CLAIMED',
            DASHBOARD_ISSUED_VOLT: 'DASHBOARD_ISSUED_VOLT',
            DASHBOARD_CLAIMED_VOLT: 'DASHBOARD_CLAIMED_VOLT',
            DASHBOARD_LIABILITY_VOLT: 'DASHBOARD_LIABILITY_VOLT',
            DASHBOARD_VOLT_LAPSED: 'DASHBOARD_VOLT_LAPSED',
            DASHBOARD_DRIVER_PIE_CHART: 'DASHBOARD_DRIVER_PIE_CHART',
            DASHBOARD_REFERRAL_PROMOTION: 'DASHBOARD_REFERRAL_PROMOTION',
            DASHBOARD_PARTNER_PROMO_CLICK_COUNT: 'DASHBOARD_PARTNER_PROMO_CLICK_COUNT',
            DASHBOARD_DASHBOARD: 'DASHBOARD_DASHBOARD',
            DASHBOARD_ENABLE_DRIVER_INDIVIDUAL_VS_ORGANISATION: 'DASHBOARD_ENABLE_DRIVER_INDIVIDUAL_VS_ORGANISATION',
            DASHBOARD_ALERT_COUNT: 'DASHBOARD_ALERT_COUNT',
            DASHBOARD_ACTIVE_PREMIUM_SUBSCRIPTIONS: 'DASHBOARD_ACTIVE_PREMIUM_SUBSCRIPTIONS',
            DASHBOARD_PREMIUM_SUBSCRIPTIONS: 'DASHBOARD_PREMIUM_SUBSCRIPTIONS',
        });
        public static readonly USERS = 'USERS_USERS';
        public static readonly USERGROUPS = 'USERS_USER_GROUPS';
        public static readonly CHARGE_STATIONS = 'CHARGE_STATIONS';
        public static readonly PAY_BY_WEB = 'PAY_BY_WEB';
        public static readonly CHARGE_STATIONS_MAP_VIEW = 'CHARGE_STATIONS_MAP_VIEW';
        public static readonly ACCESS_GROUPS = 'ACCESS_GROUPS';
        public static readonly ACCESS_GROUP_REQUESTS = 'ACCESS_GROUP_REQUESTS';
        public static readonly TRANSACTION_LOGS = 'TRANSACTION_LOGS';
        public static readonly SETTINGS_EMAIL_LOGS = 'SETTINGS_EMAIL_LOGS';
        public static readonly SETTINGS_OCPI_ERROR_LOGS = 'SETTINGS_OCPI_ERROR_LOGS';
        public static readonly RFID = Object.freeze({
            RFID_CARDS: 'RFID_CARDS',
            RFID_CARD_READERS: 'RFID_CARD_READERS',
            RFID_CARD_SCHEMES: 'RFID_CARD_SCHEMES',
        });

        public static readonly DRIVERS = Object.freeze({
            ACCOUNTS: 'DRIVERS_ACCOUNTS',
            ACCOUNT_BALANCE: 'DRIVERS_ACCOUNT_BALANCE',
            TRANSACTIONS: 'DRIVERS_TRANSACTIONS',
            REQUESTED_PROMOTIONS: 'DRIVERS_REQUESTED_PROMOTIONS',
            DRIVER_GROUPS: 'DRIVERS_DRIVER_GROUPS',
            IVAWARDS: 'DRIVERS_IVAWARDS',
            VEHICLES: 'DRIVERS_VEHICLES',
            IVAWARDS_APPROVAL: 'DRIVERS_IVAWARDS_APPROVAL',
            RFID_CARD_REQUESTS: 'RFID_CARD_REQUESTS',
            DRIVER_DEBT: 'DRIVER_DEBT',
        });
        public static readonly PROMOTIONS = Object.freeze({
            REWARD_PROMOTIONS: 'PROMOTIONS_REWARDS',
            REFERRAL_PROMOTIONS: 'PROMOTIONS_REFERRAL',
            DRIVER_PROMOTIONS: 'PROMOTIONS_DRIVER',
            TARIFF_PROMOTIONS: 'SETTINGS_TARIFF',
            PARTNER_PROMOTIONS: 'PROMOTIONS_PARTNERS',
            PROMOTIONS_PREMIUM_SUBSCRIPTIONS: 'PROMOTIONS_PREMIUM_SUBSCRIPTIONS',
            PROMOTIONS_PREMIUM_SUBSCRIPTION_IMAGES: 'PROMOTIONS_PREMIUM_SUBSCRIPTION_IMAGES',
        });
        public static readonly PAYMENTS = Object.freeze({
            SCHEDULE: 'PAYMENT_SCHEDULE',
            FAIL_PAYMENTS: 'PAYMENT_FAILURE',
            APPROVAL: 'PAYMENT_APPROVAL',
            PAYMENT_REFUND_APPROVALS: 'PAYMENT_REFUND_APPROVALS',
        });
        public static readonly MASTERS = Object.freeze({
            VAT: 'MASTERS_VAT',
            TAGS: 'MASTERS_TAGS',
            AMENITY: 'MASTERS_AMENITY',
            TERMS_AND_CONDITIONS: 'MASTERS_TERMS_CONDITION',
            PSP: 'SETTINGS_PSP',
            SETTINGS_CONFIGURATIONS: 'SETTINGS_CONFIGURATIONS',
            SETTINGS_DATA_AGGREGATORS: 'SETTINGS_DATA_AGGREGATORS',
            SETTINGS_DRIVER_DEBTOR_LETTER: 'SETTINGS_DRIVER_DEBTOR_LETTER',
            SETTINGS_GLOBAL_SERVICE: 'SETTINGS_GLOBAL_SERVICE',
        });

        public static readonly CHARGING_SESSIONS = Object.freeze({
            INCOMPLETE_SESSIONS: 'CHARGING_SESSIONS_INCOMPLETE_SESSIONS',
            OCPI_SESSIONS: 'CHARGING_SESSIONS_OCPI_SESSIONS',
        });

        public static readonly CPOS = Object.freeze({
            ACCOUNTS: 'CPOS_ACCOUNTS',
            CPOS_INTERNAL_TRANSFER: 'CPOS_INTERNAL_TRANSFER',
        });

        public static readonly ORGANISATIONS = Object.freeze({
            ACCOUNTS: 'ORGANISATIONS_ACCOUNTS',
            ACCOUNT_BALANCE: 'ORGANISATIONS_ACCOUNT_BALANCE',
            ORGANISATIONS_TRANSACTIONS: 'ORGANISATIONS_TRANSACTIONS',
            ORGANISAIONS_INVOICES: 'ORGANISAIONS_INVOICES',
            ORGANISATIONS_DASHBOARD: 'ORGANISATIONS_DASHBOARD',
            ORGANISATIONS_DASHBOARD_RFID_SUMMARY: 'ORGANISATIONS_DASHBOARD_RFID_SUMMARY',
            ORGANISATIONS_DASHBOARD_TOTAL_DRIVERS: 'ORGANISATIONS_DASHBOARD_TOTAL_DRIVERS',
            ORGANISATIONS_DASHBOARD_REMAINING_CREDIT: 'ORGANISATIONS_DASHBOARD_REMAINING_CREDIT',
            ORGANISATIONS_DASHBOARD_DRIVERS_USAGE: 'ORGANISATIONS_DASHBOARD_DRIVERS_USAGE',
            ADMIN_ORGANISATION_DASHBOARD: 'ADMIN_ORGANISATION_DASHBOARD',
        });

        static FLEET_PORTAL = class Fleet {
            public static readonly DRIVER_VEHICLE = Object.freeze({
                DRIVER_VEHICLE_ACCOUNT: 'FLEET_DRIVER_ACCOUNTS',
                DRIVER_GROUPS: 'FLEET_DRIVERS_GROUPS',
                FLEET_DRIVER_SPEND_LIMIT_HISTORY: 'FLEET_DRIVER_SPEND_LIMIT_HISTORY',
            });
            public static readonly FLEET_SETTINGS = Object.freeze({
                USERS: 'FLEET_SETTINGS_USERS',
                RFID_CARDS: 'FLEET_SETTINGS_RFID_CARDS',
                API_KEY: 'FLEET_SETTINGS_API_KEY',
                FLEET_PAYMENT_SOURCE: 'FLEET_PAYMENT_SOURCE',
                FLEET_SETTINGS_PROFILE: 'FLEET_SETTINGS_PROFILE',
            });
            public static readonly FLEET_DASHBOARD = Object.freeze({
                FLEET_DASHBOARD_USER_SESSION: 'FLEET_DASHBOARD_USER_SESSION',
                FLEET_DASHBOARD_EXPENSE: 'FLEET_DASHBOARD_EXPENSE',
                FLEET_DASHBOARD_TRANSACTION: 'FLEET_DASHBOARD_TRANSACTION',
                FLEET_DASHBOARD_ENERGY: 'FLEET_DASHBOARD_ENERGY',
                FLEET_DASHBOARD_REMAINING_CREDIT: 'FLEET_DASHBOARD_REMAINING_CREDIT',
                FLEET_DASHBOARD_DRIVER_PIE_CHART: 'FLEET_DASHBOARD_DRIVER_PIE_CHART',
                FLEET_DASHBOARD_DASHBOARD: 'FLEET_DASHBOARD_DASHBOARD',
            });
            public static readonly FLEET_STATIONS = Object.freeze({
                FLEET_ACCESS_GROUPS: 'FLEET_ACCESS_GROUPS',
                FLEET_ACCESS_GROUP_REQUESTS: 'FLEET_ACCESS_GROUP_REQUESTS',
            });
        };
        public static readonly FLEET_HISTORY = Object.freeze({
            CDR_HISTORY: 'FLEET_CDR_HISTORY',
            PAYMENT_HISTORY: 'FLEET_PAYMENT_HISTORY',
        });
        public static readonly FLEET_DASHBOARD = Object.freeze({
            FLEET_DASHBOARD_USER_SESSION: 'FLEET_DASHBOARD_USER_SESSION',
            FLEET_DASHBOARD_EXPENSE: 'FLEET_DASHBOARD_EXPENSE',
            FLEET_DASHBOARD_TRANSACTION: 'FLEET_DASHBOARD_TRANSACTION',
            FLEET_DASHBOARD_ENERGY: 'FLEET_DASHBOARD_ENERGY',
            FLEET_DASHBOARD_REMAINING_CREDIT: 'FLEET_DASHBOARD_REMAINING_CREDIT',
            FLEET_DASHBOARD_DRIVER_PIE_CHART: 'FLEET_DASHBOARD_DRIVER_PIE_CHART',
        });
        public static readonly ADVERTISING = Object.freeze({
            ADVERTISING_DEVICES: 'ADVERTISING_DEVICES',
            ADVERTISING_VIDEOS: 'ADVERTISING_VIDEOS',
            ADVERTISING_CREDENTIALS: 'ADVERTISING_CREDENTIALS',
        });
    };

    static Actions = class Actions {
        public static readonly CAN_VIEW = 'VIEW';
        public static readonly CAN_DELETE = 'DELETE';
        public static readonly CAN_UPDATE = 'UPDATE';
        public static readonly CAN_EXPORT = 'EXPORT';
        public static readonly CAN_ADD = 'ADD';
        public static readonly CAN_IMPORT = 'IMPORT';
        public static readonly CAN_ASSIGN_PERMISSION = 'ASSIGN_PERMISSION';
        public static readonly CAN_ASSIGN_RFID = 'ASSIGN_RFID';
        public static readonly CAN_FAIL_TRANS_DETAIL_USER = 'FAIL_TRANS_DETAIL_USER';
        public static readonly CAN_FAIL_TRANS_DETAIL_ADMIN = 'FAIL_TRANS_DETAIL_ADMIN';
        public static readonly CAN_ASSIGN_CHARGE_STATION = 'ASSIGN_CHARGE_STATION';
        public static readonly ASSIGN_CHARGE_TARIFF = 'ASSIGN_CHARGE_TARIFF';
        public static readonly RESET_2FA = 'RESET_2FA';
        public static readonly START_REMOTE_CHARGE = 'START_REMOTE_CHARGE';
        public static readonly RESET_PASSWORD = 'RESET_PASSWORD';
        public static readonly UPDATE_PAYMENT_CARD_STATUS = 'UPDATE_PAYMENT_CARD_STATUS';
        public static readonly SYNCHRONIZE_STATIONS = 'SYNCHRONIZE_STATIONS';
        public static readonly SYNCHRONIZE_DASHBOARD = 'SYNCHRONIZE_DASHBOARD';
        public static readonly MANAGE_AMENITIES = 'MANAGE_AMENITIES';
        public static readonly ASSIGN_CHARGE_LOCATION = 'ASSIGN_CHARGE_LOCATION';
        public static readonly ASSIGN_DRIVER = 'ASSIGN_DRIVER';
        public static readonly VIEW_CHARGE_LOCATION = 'VIEW_CHARGE_LOCATION';
        public static readonly VIEW_DRIVER_ACTIVITIES = 'VIEW_DRIVER_ACTIVITIES';
        public static readonly CAN_DOWNLOAD = 'DOWNLOAD';
        public static readonly ASSIGN_ADVERTISING_DEVICES = 'ASSIGN_ADVERTISING_DEVICES';
        public static readonly ASSIGN_ADVERTISING_VIDEOS = 'ASSIGN_ADVERTISING_VIDEOS';
        public static readonly EXTRACT_LOCATION_DATA = 'EXTRACT_LOCATION_DATA';
        public static readonly REGENERATE_S3_FILE = 'REGENERATE_S3_FILE';
        public static readonly VIEW_MEDIA_PLAY_LOG_HISTORY = 'VIEW_MEDIA_PLAY_LOG_HISTORY';
        public static readonly DOWNLOAD_DEBT_LETTER = 'DOWNLOAD_DEBT_LETTER';
        public static readonly GENERATE_CHASE_REPORT = 'GENERATE_CHASE_REPORT';
        public static readonly SYNCHRONIZE_ORGANISATION_DASHBOARD = 'SYNCHRONIZE_ORGANISATION_DASHBOARD';
        public static readonly MANAGE_PREMIUM_SUBSCRIPTIONS = 'MANAGE_PREMIUM_SUBSCRIPTIONS';
        public static readonly VIEW_DRIVERS_USAGE_DASHBOARD = 'VIEW_DRIVERS_USAGE_DASHBOARD';
        public static readonly VIEW_TOTAL_DRIVERS_DASHBOARD = 'VIEW_TOTAL_DRIVERS_DASHBOARD';
        public static readonly VIEW_REMAINING_CREDIT_DASHBOARD = 'VIEW_REMAINING_CREDIT_DASHBOARD';
        public static readonly VIEW_RFID_SUMMARY_DASHBOARD = 'VIEW_RFID_SUMMARY_DASHBOARD';
        public static readonly VIEW_TOTAL_ENERGY_DASHBOARD = 'VIEW_TOTAL_ENERGY_DASHBOARD';
        public static readonly VIEW_TOTAL_INCOME_DASHBOARD = 'VIEW_TOTAL_INCOME_DASHBOARD';
        public static readonly VIEW_USER_SESSION_DASHBOARD = 'VIEW_USER_SESSION_DASHBOARD';
        public static readonly MARK_AS_FAKE_ACCOUNT = 'MARK_AS_FAKE_ACCOUNT';
        public static readonly VIEW_NOTE = 'VIEW_NOTE';
        public static readonly ADD_NOTE = 'ADD_NOTE';
        public static readonly REGENERATE_DEBT_LETTER = 'REGENERATE_DEBT_LETTER';
        public static readonly PREVIEW = 'PREVIEW';
        public static readonly FORCE_CPO_UPDATE = 'FORCE_CPO_UPDATE';
        public static readonly VIEW_DRIVER_DEBT_LETTER_HISTORY = 'VIEW_DRIVER_DEBT_LETTER_HISTORY';
        public static readonly SYNC_TO_GLOBAL_SYSTEM = 'SYNC_TO_GLOBAL_SYSTEM';
        public static readonly EXPORT_SUBSCRIBED_DRIVERS = 'EXPORT_SUBSCRIBED_DRIVERS';
        public static readonly TARIFF_UPDATE = 'TARIFF_UPDATE';
        public static readonly PROMOTION_UPDATE = 'PROMOTION_UPDATE';
        public static readonly UPDATE_REFERRAL_CODE_STATUS = 'UPDATE_REFERRAL_CODE_STATUS';
        public static readonly SEARCH_DRIVER_PAYMENT_CARDS = 'SEARCH_DRIVER_PAYMENT_CARDS';
        public static readonly CLAIM_UNALLOCATED_CARD_READERS = 'CLAIM_UNALLOCATED_CARD_READERS';
        public static readonly SYNC_DATA_AGGREGATOR_API_KEYS = 'SYNC_DATA_AGGREGATOR_API_KEYS';
        public static readonly VIEW_ASSOCIATED_TARIFFS = 'VIEW_ASSOCIATED_TARIFFS';
        public static readonly UPDATE_PROMOTION_TARIFF = 'UPDATE_PROMOTION_TARIFF';
        public static readonly MANAGE_OVERRIDE_TARIFF = 'MANAGE_OVERRIDE_TARIFF';
        public static readonly CANCEL_PENDING_TRANSACTIONS = 'CANCEL_PENDING_TRANSACTIONS';
    };

    static ImageFormats = ['image/jpg', 'image/jpeg', 'image/svg', 'image/svg+xml', 'image/png'];
    static VideoFormats = [
        'video/mp4',
        'video/x-flv',
        'video/x-ms-wmv',
        'video/mpeg',
        'video/x-msvideo',
        'video/3gpp',
        'video/avi',
    ];

    static RFIDCardsImportFormats = ['text/csv'];
    static CertificateFormats = ['application/pkix-cert', 'application/x-x509-ca-cert', 'application/x-x509-user-cert'];

    static Colors = class Colors {
        public static readonly PRIMARY = 'primary';
        public static readonly DANGER = 'danger';
        public static readonly SECONDARY = 'secondary';
    };

    static Modes = class Modes {
        public static readonly ADD = 'Add';
        public static readonly Edit = 'Edit';
    };

    static AuthChallengeName = class AuthChallengeName {
        public static readonly NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
        public static readonly MFA_SETUP = 'MFA_SETUP';
        public static readonly SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
        public static readonly TOTP = 'TOTP';
        public static readonly SUCCESS = 'success';
    };

    static Auth = class Auth {
        public static readonly NOT_AUTHORIZED_EXCEPTION =
            'Temporary password has expired and must be reset by an administrator.';
        public static readonly CODE_MISS_MATCH_EXCEPTION = 'CodeMismatchException';
        public static readonly ENABLE_MFA_TOKEN_EXCEPTION = 'EnableSoftwareTokenMFAException';
        public static readonly NOT_AUTHORIZED = 'NotAuthorizedException';
        public static readonly NOMFA = 'NOMFA';
        public static readonly TOTP = 'TOTP';
        public static readonly SECURITY_CODE_INVALID = 'EnableSoftwareTokenMFAException';
    };

    static AuthStage = class AuthStage {
        public static readonly SIGNIN = 0;
        public static readonly QR_SCAN = 1;
        public static readonly VERIFICATION_CODE = 2;
        public static readonly FORGOT_PASSWORD = 3;
        public static readonly CHANGE_PASSWORD = 4;
        public static readonly CHANGE_PASSWORD_WITH_VERIFICATION_CODE = 5;
    };

    static UserStatus = class UserStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
        public static readonly PENDING = 'PENDING';
        public static readonly DELETED = 'DELETED';
    };
    static UserGroupStatus = class UserGroupStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
        public static readonly DELETED = 'DELETED';
    };
    static TagStatus = class TagStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static DriverStatus = class UserStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
        public static readonly CANCELLED = 'CANCELLED';
        public static readonly DELETED = 'DELETED';
        public static readonly PENDING = 'PENDING';
        public static readonly ONSTOP = 'ONSTOP';
        public static readonly BAD_DEBTOR = 'BAD_DEBTOR';
        public static readonly FAKE_ACCOUNT = 'FAKE_ACCOUNT';
    };
    static DriverBalanceType = class UserStatus {
        public static readonly ACCOUNT_BALANCE = 'REFUND';
        public static readonly REWARD_BALANCE = 'REFUND_REWARD_BONUS';
        public static readonly REFERRAL_BONUS = 'REFUND_REFERRAL_BONUS';
    };

    static DriverAccountType = class DriverAccountType {
        public static readonly DRIVER = 'DRIVER';
        public static readonly VEHICLE = 'VEHICLE';
        public static readonly FLEET_DRIVER = 'FLEET_DRIVER';
    };
    static DriverPaymentType = class DriverPaymentType {
        public static readonly CREDIT_ACCOUNT = 'CREDIT_ACCOUNT';
        public static readonly PREPAYMENT_ACCOUNT = 'PREPAYMENT_ACCOUNT';
    };
    static DriverGroupStatus = class DriverGroupStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static RegularExpression = class RegularExpression {
        public static readonly EmailRegularExpression = new RegExp(
            /(?=^.{1,64}@.{1,255}$)^([a-zA-Z0-9%_.+-]+)@((([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,})+)|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})$/,
        );
        public static readonly PasswordRegularExpression = new RegExp(
            /^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])[\p{L}\d!@#$%^&*()\-_=+{};:,<.>]{15,99}$/u,
        );
        public static readonly AlphabetRegex = new RegExp(/[\p{L}]*^[^*\^@&%#~_\-+!$(){}<>?\/\\,.:;`'"|0-9\s]*$/);
        public static readonly CodeRegularExpression = new RegExp(/^[0-9]{6}$/);
        public static readonly NameRegularExpression = new RegExp(/[\p{L}]*^[^*\^@&%#~_+!$(){}<>?\/\\,.:;`'"|0-9]*$/);
        public static readonly PhoneNumberRegularExpression = new RegExp(/^[0-9+-]*$/);
        public static readonly GroupNameRegularExpression = new RegExp(/[\p{L}]*^[^*\^@&%#~_+!$(){}<>?\/\\,.:;`'"|]*$/);
        public static readonly AlphaNumericWithSpaceAndDashRegex = new RegExp(
            /[\p{L}]*^[^*\^@&%#~_+!$(){}<>?\/\\,.:;`'"|]*$/,
        );
        public static readonly AlphaNumericWithSpaceAndDashUnderScoreRegex = new RegExp(
            /[\p{L}]*^[^*\^@&%#~+!$(){}<>?\/\\,.:;`'"|]*$/,
        );
        public static readonly AlphaNumericWithSpaceAndDashUnderScoreApostrophesRegex = new RegExp(
            /[\p{L}]*^[^*\^@&%#~+!$(){}<>?\/\\,.:;`"|]*$/,
        );
        public static readonly AlphaNumericWithDashUnderScoreRegex = new RegExp(
            /[\p{L}]*[0-9]*^[^*^@&%#+!$(){}<>?/\\,.:;`"~|='\[\]]+$/,
        );
        public static readonly AlphaNumericRegex = new RegExp(/[\p{L}]*^[^*\^@&%#~_\-+!$(){}<>?\/\\,.:;`'"|\s]*$/);
        public static readonly VatRateRegularExpression = new RegExp(/^[0-9]*\.?\,?[0-9]*$/);
        public static readonly AmountRegularExpression = new RegExp(/^[0-9]*\.?\,?[0-9]*$/);
        public static readonly DigitsAndPointRegularExpression = new RegExp(/^[0-9]*\.?\,?[0-9]*$/);
        public static readonly DigitsAndPointMinusRegularExpression = new RegExp(/^[-]?[0-9]*\.?\,?[0-9]*$/);
        public static readonly DigitsRegularExpression = new RegExp(/^[0-9]*$/);
        public static readonly DigitsExcludingOnlyZeroRegularExpression = new RegExp(/^(?!0+$)[0-9]{0,10}$/);
        public static readonly DigitsAndMinusRegularExpression = new RegExp(/^[-]?[0-9]*$/);
        public static readonly AmountWithMinusValueRegularExpression = new RegExp(/^-?[0-9]*\.?\,?[0-9]*$/);
        public static readonly CVVRegularExpression = new RegExp(/^[0-9]*$/);
        public static readonly FullNameRegularExpression = new RegExp(/[\p{L}]*^[^*\^@&%#~_+!$(){}<>?\/\\,.:;`'"|]*$/);
        public static readonly DigitsWithSpacesRegularExpression = new RegExp(/^[0-9\s]*$/);
        public static readonly ColourCodeRegularExpression = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
        public static readonly DriverPasswordRegularExpression = new RegExp(
            /^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])[\p{L}\d!@#$%^&*()\-_=+{};:,<.>]{10,99}$/u,
        );
        public static readonly AlphaNumericWithSpaceDashAndUnderScoreRegex = new RegExp(
            /[\p{L}]*^[^*\^@&%#~+!$(){}<>?\/\\,.:;`'"|]*$/,
        );
        public static readonly AlphaNumericWithSpaceRegex = new RegExp(
            /[\p{L}]*^[^*\^@&%#~_\-+!$(){}<>?\/\\,.:;`'"|]*$/,
        );
        public static readonly DriverDebtLetterDynamicFieldsRegex = new RegExp(/\{{.*?\}}/g);
        public static readonly AddressRegularExpression = new RegExp(/^[\p{L}\p{N}\s.,&-/()#'"!$%^+=<>?@_{}:;~|]+$/u);
        public static readonly GeneralAddressRegularExpression = new RegExp(
            /^[A-Za-zÀ-ſĀ-ſα-ωΑ-Ω\r\n\d.,?!":;€£$%^&*()_+=\[\]#@<>`\\ \-'\/]+$/u,
        );
        public static readonly GeneralNameFieldRegularExpression = new RegExp(/^[\p{L}\p{N}'\s_-]+$/u);
    };
    static VatStatus = class VatStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static TransactionType = class TransactionType {
        public static readonly CHARGE = 'CHARGE';
        public static readonly PAYMENT = 'PAYMENT';
    };
    static AccountType = class AccountType {
        public static readonly DRIVER = 'Driver';
        public static readonly VEHICLE = 'Vehicle';
        public static readonly FLEET_DRIVER = 'FLEET_DRIVER';
    };
    static RFIDCardType = class AccountType {
        public static readonly MIFARE_ONLY = 'MIFARE_ONLY';
        public static readonly NEMA_ENABLED = 'NEMA_ENABLED';
        public static readonly VIRTUAL = 'VIRTUAL';
    };
    static PaymentAuditStatus = class PaymentAuditStatus {
        public static readonly PENDING = 'PENDING';
        public static readonly ACKNOWLEDGED = 'ACKNOWLEDGED';
        public static readonly CLOSED = 'CLOSED';
    };
    static DayOfWeek = class DayOfWeek {
        public static readonly MONDAY = 'MONDAY';
        public static readonly TUESDAY = 'TUESDAY';
        public static readonly WEDNESDAY = 'WEDNESDAY';
        public static readonly THURSDAY = 'THURSDAY';
        public static readonly FRIDAY = 'FRIDAY';
        public static readonly SATURDAY = 'SATURDAY';
        public static readonly SUNDAY = 'SUNDAY';
    };
    static PaymentScheduleType = Object.freeze({
        DAILY: 'DAILY',
        WEEKLY: 'WEEKLY',
    });

    static PaymentType = Object.freeze({
        CREDIT_PAYMENT: 'CREDIT_ACCOUNT',
        PRE_PAYMENT: 'PREPAYMENT_ACCOUNT',
    });

    static DriverAccountStatus = Object.freeze({
        ENABLED: 'Enabled',
        DISABLED: 'Disabled',
    });

    static RefundType = Object.freeze({
        REFUND: 'REFUND',
        ADDITIONAL_PAYMENT: 'ADDITIONAL_PAYMENT',
    });
    static DriverPromotionStatus = class DriverPromotionStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static PromotionsRequestStatus = class PromotionsRequestStatus {
        public static readonly APPROVED = 'APPROVED';
        public static readonly PENDING = 'PENDING';
        public static readonly REJECTED = 'REJECTED';
    };

    static RefundApprovalStatus = Object.freeze({
        PENDING: 'PENDING',
        APPROVED: 'APPROVED',
        DECLINED: 'DECLINED',
    });

    static PaymentApprovalType = Object.freeze({
        DRIVER: 'Driver',
        ORGANISATION: 'Organisation',
    });
    static TariffSatus = class TariffSatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DELETED = 'DELETED';
    };
    static AmenitysStatus = Object.freeze({
        ENABLE: 'ENABLE',
        DISABLE: 'DISABLE',
    });
    static ReferralPromotionStatus = class ReferralPromotionStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static TermsConditionsStatus = Object.freeze({
        DRAFT: 'DRAFT',
        PUBLISHED: 'PUBLISHED',
        ARCHIVED: 'ARCHIVED',
    });
    static LookupCode = Object.freeze({
        TERMS_STATUS: 'TERMS_STATUS',
        TERMS_APPLY_TO: 'TERMS_APPLY_TO',
        PAYMENT_MODE: 'PAYMENT_MODE',
        PAYMENT_SCHEDULE: 'PAYMENT_SCHEDULE',
        SESSION_STATUS: 'SESSION_STATUS',
        ACCOUNT_TYPE: 'ACCOUNT_TYPE',
        RFID_CARD_STATUS: 'RFID_CARD_STATUS',
        RFID_CARD_REQUEST_STATUS: 'RFID_CARD_REQUEST_STATUS',
        DRIVER_REFUND_STATUS: 'DRIVER_REFUND_STATUS',
        TRANSACTION_TYPE: 'TRANSACTION_TYPE',
        PAYMENT_REFUND_TYPE: 'PAYMENT_REFUND_TYPE',
        CARD_READER_STATUS: 'CARD_READER_STATUS',
        EVSE_STATUS: 'EVSE_STATUS',
        RFID_CARD_TYPE: 'RFID_CARD_TYPE',
        ACCESS_CONTROL_TYPE: 'ACCESS_CONTROL_TYPE',
        ACCESS_GROUP_REQUEST_STATUS: 'ACCESS_GROUP_REQUEST_STATUS',
        SUBSCRIPTION_TYPE: 'SUBSCRIPTION_TYPE',
        ADVERTISING_DEVICE_STATUS: 'ADVERTISING_DEVICE_STATUS',
        CPO_VAT_TYPE: 'CPO_VAT_TYPE',
        ADVERTISING_DEVICE_SCREEN_SIZE: 'ADVERTISING_DEVICE_SCREEN_SIZE',
        ADVERTISING_VIDEO_STATUS: 'ADVERTISING_VIDEO_STATUS',
        POWER_TYPE: 'POWER_TYPE',
        INVOICE_STATUS: 'INVOICE_STATUS',
        TARIFF_AMOUNT_TYPE: 'TARIFF_AMOUNT_TYPE',
        DRIVERS_STATUS: 'DRIVERS_STATUS',
        SPEND_LIMIT_TYPE: 'SPEND_LIMIT_TYPE',
        PSP_TYPE: 'PSP_TYPE',
        CHASE_REPORT_TYPE: 'CHASE_REPORT_TYPE',
        STRIKE_ONE: 'STRIKE_ONE',
        STRIKE_TWO: 'STRIKE_TWO',
        IN_PROGRESS: 'IN_PROGRESS',
        COMPLETED: 'COMPLETED',
        BAD_DEBT_STRIKE_ONE_DEBT_AGE: 'BAD_DEBT_STRIKE_ONE_DEBT_AGE',
        BAD_DEBT_STRIKE_TWO_DEBT_AGE: 'BAD_DEBT_STRIKE_TWO_DEBT_AGE',
        PROMOTION_DISPLAY_TYPE: 'PROMOTION_DISPLAY_TYPE',
        AMENITY_TYPE: 'AMENITY_TYPE',
        DRIVER_GROUP: 'DRIVER_GROUP',
    });
    static RewardPromotionStatus = class RewardPromotionStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static DriverVehicleAccountStatus = class DriverVehicleStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
        public static readonly CANCELLED = 'CANCELLED';
        public static readonly DELETED = 'DELETED';
        public static readonly PENDING = 'PENDING';
        public static readonly DELETING = 'DELETING';
    };
    static DriverVehicleAccountType = class DriverVehicleAccountType {
        public static readonly DRIVER = 'DRIVER';
        public static readonly VEHICLE = 'VEHICLE';
    };
    static ChargeStationModelType = Object.freeze({
        AMENITY: 'amenity',
    });
    static OrganisationsStatus = Object.freeze({
        ENABLE: 'ENABLE',
        DISABLE: 'DISABLE',
    });
    static DriverAwardStatus = class DriverAwardStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static RewardApprovalStatus = Object.freeze({
        PENDING: 'PENDING',
        APPROVED: 'APPROVED',
        DECLINED: 'DECLINED',
    });
    static RewardApprovalSType = Object.freeze({
        DEBIT: 'Dr',
        CREDIT: 'Cr',
    });

    static RFID_CARD_STATUS = Object.freeze({
        UNDER_PROGRESS: 'UNDER_PROGRESS',
        AWAITING_EXPORT: 'AWAITING_EXPORT',
        MANUFACTURING: 'MANUFACTURING',
        AVAILABLE: 'AVAILABLE',
        ALLOCATED: 'ALLOCATED',
        DISABLED: 'DISABLED',
        ACTIVATED: 'ACTIVATED',
        DUPLICATE: 'DUPLICATE',
    });
    static RFID_REQUEST_CARD_STATUS = Object.freeze({
        APPROVED: 'APPROVED',
        DECLINED: 'DECLINED',
        PENDING: 'PENDING',
        ALLOCATED: 'ALLOCATED',
        CLOSED: 'CLOSED',
    });

    static CHARGE_TYPE = Object.freeze({
        ENERGY: 'ENERGY',
        FLAT: 'FLAT',
        MAX_CURRENT: 'MAX_CURRENT',
        MIN_CURRENT: 'MIN_CURRENT',
        PARKING_TIME: 'PARKING_TIME',
        TIME: 'TIME',
    });

    static SYSTEM_TYPE = Object.freeze({
        ADMIN: 'ADMIN',
        DRIVER: 'DRIVER',
        SYSTEM: 'SYSTEM',
    });
    static PaymentCardTypeImage = Object.freeze({
        VISA: 'visa.svg',
        AMEX: 'amex.svg',
        DINERS_CLUB_CARTE_BLANCHE: 'diners_club_carte_blanche.svg',
        DINERS_CLUB_INTERNATIONAL: 'diners_club_carte_blanche.svg',
        JCB: 'jcb.svg',
        LASER: 'laser.svg',
        VISA_ELECTRON: 'visa_electron.svg',
        MASTERCARD: 'mastercard.svg',
        DISCOVER: 'discover.svg',
        DANKORT: 'dankort.svg',
        MAESTRO: 'maestro.svg',
        UATP: 'uatp.svg',
    });
    static PaymentCardType = Object.freeze({
        VISA: 'VISA',
        AMEX: 'AMEX',
        DINERS_CLUB_CARTE_BLANCHE: 'DINERS_CLUB_CARTE_BLANCHE',
        DINERS_CLUB_INTERNATIONAL: 'DINERS_CLUB_INTERNATIONAL',
        JCB: 'JCB',
        LASER: 'LASER',
        VISA_ELECTRON: 'VISA_ELECTRON',
        MASTERCARD: 'MASTERCARD',
        DISCOVER: 'DISCOVER',
        DANKORT: 'DANKORT',
        MAESTRO: 'MAESTRO',
        UATP: 'UATP',
    });

    static PayemntCode = 'Optomany';

    static PaymentMode = class PaymentMode {
        public static readonly PURCHASE_ORDER = 'PURCHASE_ORDER';
        public static readonly CREDIT_CARD = 'CREDIT_CARD';
    };

    static PaymentStage = class PaymentStage {
        public static readonly ADD_EDIT_CARD = 'ADD_EDIT_CARD';
        public static readonly CARD_DETAILS = 'CARD_DETAILS';
        public static readonly PROCESSING = 'PROCESSING';
        public static readonly CARD_DETAILS_PSP = 'CARD_DETAILS_PSP';
    };
    static RefundRequestStatus = Object.freeze({
        PROCESSINNG: 'PROCESSING',
        COMPLETE: 'COMPLETE',
        DECLINED: 'DECLINED',
        CANCELLED: 'CANCELED',
    });
    static DriverPromotionCodeStatus = Object.freeze({
        UNUSED: 'UNUSED',
        USED: 'USED',
    });
    static PaymentActionCode = Object.freeze({
        THREEDS_REPLACE_CARD: '3DS_REPLACE_CARD',
        THREEDS_SAVE_CARD: '3DS_SAVE_CARD',
        REPLACE_CARD: 'REPLACE_CARD',
        SAVE_CARD: 'SAVE_CARD',
    });
    static ConfigurationKey = Object.freeze({
        SAVE_CARD_CHARGE_FLEET: 'SAVE_CARD_CHARGE_FLEET',
        CONTACT_US_ADDRESS: 'CONTACT_US_ADDRESS',
        INSTAVOLT_WEBSITE: 'INSTAVOLT_WEBSITE',
        CONTACT_US_PHONE: 'CONTACT_US_PHONE',
        COMPANY_NUMBER: 'COMPANY_NUMBER',
        ADMIN_PORTAL_U_GUIDE_URL: 'ADMIN_PORTAL_U_GUIDE_URL',
        FLEET_PORTAL_U_GUIDE_URL: 'FLEET_PORTAL_U_GUIDE_URL',
        ORG_BALANCE_APPROVAL: 'ORG_BALANCE_APPROVAL',
        ORG_BAL_APP_OFF_USER_LIST: 'ORG_BAL_APP_OFF_USER_LIST',
        LIMITED_KWH: 'LIMITED_KWH',
        LIMITED_KWH_EMAIL_ACCOUNT: 'LIMITED_KWH_EMAIL_ACCOUNT',
        COGNITO_MFA_STATUS: 'COGNITO_MFA_STATUS',
        MAP_AUTO_REFRESH_TIME: 'MAP_AUTO_REFRESH_TIME',
        SINGLE_VIDEO_UPLOAD_LIMIT: 'SINGLE_VIDEO_UPLOAD_LIMIT',
        ENABLE_PREMIUM_SUBSCRIPTION: 'ENABLE_PREMIUM_SUBSCRIPTION',
        UNIT_OF_DISTANCE: 'UNIT_OF_DISTANCE',
        ENABLE_GOOGLE_PAY_APPLE_PAY_DNA: 'ENABLE_GOOGLE_PAY_APPLE_PAY_DNA',
    });
    static PaymentTransactionType = Object.freeze({
        CREDIT: 'CREDIT',
        DEBIT: 'DEBIT',
    });
    static CardReaderStatusCode = Object.freeze({
        ACTIVE: 'ACTIVE',
        DISABLED: 'DISABLED',
        AWAITING_ACTIVATION: 'AWAITING_ACTIVATION',
        AWAITING_APPROVAL: 'AWAITING_APPROVAL',
        DUPLICATE: 'DUPLICATE',
    });
    static CardSchemeStatus = class CardSchemeStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static StationStatus = Object.freeze({
        AVAILABLE: 'AVAILABLE',
    });
    static SESSION_STATUS = Object.freeze({
        CANCELLED: 'CANCELLED',
        ACTIVE: 'ACTIVE',
        PENDING: 'PENDING',
        INVALID: 'INVALID',
    });
    static AccessGroupStatus = class AccessGroupStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };
    static AccessControlType = Object.freeze({
        REQUEST_APPROVE_ORGANISATION: 'REQUEST_APPROVE_ORGANISATION',
        REQUEST_APPROVE_INSTAVOLT: 'REQUEST_APPROVE_INSTAVOLT',
        ON_CODE_ENTRY: 'ON_CODE_ENTRY',
    });
    static ACCESS_GROUP_REQUEST_STATUS = Object.freeze({
        APPROVED: 'APPROVED',
        DECLINED: 'DECLINED',
        PENDING: 'PENDING',
    });
    static AdvertisingDeviceStatus = class AdvertisingDeviceStatus {
        public static readonly DISABLED = 'DISABLED';
        public static readonly OPERATIONAL = 'OPERATIONAL';
        public static readonly FAULTY = 'FAULTY';
        public static readonly DELETED = 'DELETED';
    };
    static AdvertisingVideoStatus = class AdvertisingVIdeoStatus {
        public static readonly AWAITING_APPROVAL = 'AWAITING_APPROVAL';
        public static readonly APPROVED = 'APPROVED';
        public static readonly REJECTED = 'REJECTED';
        public static readonly DELETED = 'DELETED';
    };

    static INVOICE_PAYMENT_ACTION = Object.freeze({
        pay: 'Pay',
        part_pay: 'PartPay',
        adjust_amount: 'AdjustAmount',
        dispute: 'Dispute',
        undo: 'Undo',
    });

    static ORGANISATION_INVOICE_STATUS = Object.freeze({
        DISPUTED: 'DISPUTED',
        OUTSTANDING: 'OUTSTANDING',
        PART_PAID: 'PART_PAID',
        PAID: 'PAID',
        ADJUSTED: 'ADJUSTED',
    });

    static PaymentServiceProvider = Object.freeze({
        DNA: 'DNA',
        OPTOMANY: 'OPTOMANY',
        DATATRANS: 'DATATRANS',
    });

    static ReportTypes = Object.freeze({
        STRIKE_ONE: 'STRIKE_ONE',
        STRIKE_TWO: 'STRIKE_TWO',
        STRIKE_ONE_INPROGRESS: 'STRIKE_ONE_INPROGRESS',
        STRIKE_TWO_INPROGRESS: 'STRIKE_TWO_INPROGRESS',
    });

    static DriverDebtorLettersStatus = class DriverDebtorLettersStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };

    static DriverDebtLetterDynamicFields = [
        '{{DRIVER_NAME}}',
        '{{DRIVER_DEBT}}',
        '{{DEBT_AGE}}',
        '{{DRIVER_EMAIL}}',
        '{{DRIVER_ADDR}}',
        '{{DATE}}',
        '{{UNIQUE_REFERENCE}}',
    ];

    static PartnerPromotionDisplayTypes = Object.freeze({
        RAISE_NOTIFICATION_WHEN_CHARGE_IS_STARTED: 'RAISE_NOTIFICATION_WHEN_CHARGE_IS_STARTED',
        DISPLAY_LOCATION_PAGE_IMAGE: 'DISPLAY_LOCATION_PAGE_IMAGE',
        BOTH: 'BOTH',
    });

    static CommonStatus = class CommonStatus {
        public static readonly ENABLE = 'ENABLE';
        public static readonly DISABLE = 'DISABLE';
    };

    static MutualOCPIVersions = Object.freeze({
        VERSION_2_1_1: '2.1.1',
        VERSION_2_2: '2.2',
        VERSION_2_2_1: '2.2.1',
    });

    static status = Object.freeze({
        ENABLE: 'Enable',
        DISABLE: 'Disable',
    });

    static DriverGroupType = Object.freeze({
        STANDARD: 'STANDARD',
        SPEND_LIMIT: 'SPEND_LIMIT',
    });
}

export const DatatransSupportCards = ['VIS', 'ECA', 'AMX', 'CUP', 'DIN', 'DIS', 'JCB', 'MAU', 'DNK'];

export const StringSeparator = Object.freeze({
    Comma: ',',
    Dot: '.',
    Colon: ':',
});
